// @ts-check
"use strict"

import React from "react"

import ChatImage from "../ChatImage";
import { byIdentifier } from "@minohealth/common/utils/ids";

import { AiOutlineFullscreen } from "react-icons/ai";
import { useChatContext } from "@/services/chat-provider";

const PLACEHOLDER_IMAGE_SRC = "https://minohealth-storage.fra1.cdn.digitaloceanspaces.com/chat_placeholder_img.jpg"

/**
 * 
 * @param {Object} props
 * @param {ChatMessage["image"]} props.messageImage
 * @param {ChatMessage["text"]} props.messageText
 * @param {import(".").ChatMessageBubbleProps["previewImage"]} props.previewImage
 * @returns 
 */
export default function ChatBubbleImage({ messageImage, messageText, previewImage }) {
  const { useActiveChatSessionImages, useIsGuestMode } = useChatContext()

  const { data: chatImages } = useActiveChatSessionImages()
  const isGuestMode = useIsGuestMode()

  // /** @type {number[][] | null} */
  // const bBoxCoordsList = useMemo(() => {
	// 	return null
	// 	// if(sessionImageUrl == null) return null
	// 	// return parseBbox(messageText)
	// }, [messageText])

  // const bboxes = bBoxCoordsList?.map(item => rectFromCoords(item));

  // const image = bboxes!= null
  //   ? sessionImageUrl 
  //   : messageImage?.url?? messageImage?.localUrl?? PLACEHOLDER_IMAGE_SRC

  // if(bboxes == null && messageImage == null) return null

  if(messageImage == null) return null

  // Guest mode – the provider does not maintain a chat session, so we expect the
  // incoming `messageImage` to be a DataURL or object containing a previewUrl.
  if (isGuestMode) {
    const dataUrl = typeof messageImage === "string"
      ? messageImage
      : messageImage?.url || messageImage?.previewUrl;

    if (!dataUrl) return null;

    return (
      <div className="chat-bubble__image-wrapper">
        {/* eslint-disable-next-line jsx-a11y/alt-text */}
        <img src={dataUrl} />
      </div>
    );
  }

  const image = (() => {
    if(typeof messageImage === "string") {
      return chatImages?.find(byIdentifier(messageImage))
    }
    return messageImage
  })()

  if(image == null) return null

	return (
    // TODO: Draw bounding boxes onto image with canvas so that it can be used in the preview
		<div className="chat-bubble__image-wrapper">
      <ChatImage srcImage={image} thumbnail />

			{/* <div className="chat-bubble__image-bboxes-wrapper">
        {bboxes?.map((bBox, index) => (
          bBox != null && (
            <div 
              className="chat-bubble__image-bbox"
              style={{
                "--_left": `${bBox.left}`,
                "--_top": `${bBox.top}`,
                "--_width": `${bBox.width}`,
                "--_height": `${bBox.height}`,
                // "--_color": `${bBox.color}`,
                "--_delay": `${index * 50}ms`,
              }}
              key={index}
            ></div>
          )
        ))}
			</div> */}

      <button
        title="Preview image"
        className="chat-bubble__image-preview-btn"
        // onClick={() => previewImage?.(image, bboxes)}
        onClick={() => previewImage?.(image._id ?? image._clientId)}
      >
        <AiOutlineFullscreen />
        <span className="sr-only">Preview image</span>
      </button>
		</div>
	)
}

/** @param {number[]} coordsData */
function rectFromCoords(coordsData) {
  if (!coordsData || !Array.isArray(coordsData) || coordsData.length < 4) {
    return null;
  }

  const [xmin, ymin, xmax, ymax] = coordsData.map(v => v / 1000);

  return {
    top: ymin,
    left: xmin,
    right: xmax,
    bottom: ymax,
    width: xmax - xmin,
    height: ymax - ymin,
  };
}

/** @param {string} str */
function parseBbox(str) {
	const numberRegExp = /[\+\-]?([0-9]*\.)?[0-9]+/
	const bboxRegExp = new RegExp(`(${numberRegExp.source}(,\\s*${numberRegExp.source}){3})`)
	const bboxListRegExp = new RegExp(`\\[(${bboxRegExp.source}(;${bboxRegExp.source})*)\\]`, "g")

	const matches = str.match(bboxListRegExp)
	// const matches = bboxListRegExp.exec(str)
	if(matches == null) return null

	return matches.map(matchStr => {
		const match = (new RegExp(bboxListRegExp.source)).exec(matchStr)
		if(match == null) return null

		const bboxListStr = match[1]
	
	const bboxes = bboxListStr.split(";").map(bboxStr => bboxStr.split(/,\s*/).map(parseFloat))
	
		if(bboxes.length === 0) return null
		return bboxes
	}).filter(v => v != null).flat()
}